import loadable from "@loadable/component";

export const AddLockerStation = loadable(() => import("./add"));

export const EditLockerStation = loadable(() => import("./edit"));

export const LockerStationDetail = loadable(() => import("./show"));

export const ServiceAssociatedLocker = loadable(() => import("./service-associated-locker"));
